import { useMutation } from "react-query";
import { updateSafeMake } from "../../../../../actions/Utilities/SafeMake";
import { toast } from "components/toastNotification";
import { ISafeMake } from "../types";
import { editStateSafeMake, safeMakeReFetching } from "../atoms/atoms";
import { useRecoilState, useSetRecoilState } from "recoil";

const useEditSafeMake = () => {
  const setActionEditState = useSetRecoilState(editStateSafeMake);
  const [isReFetching, setIsReFetching] = useRecoilState(safeMakeReFetching);
  const { mutate } = useMutation((Data: ISafeMake) => updateSafeMake(Data), {
    onSuccess: (res) => {
      if (typeof res == "object") {
        toast.fire("Updating Safe Make failed", `${res.Message}`, "error");
      } else {
        switch (true) {
          case res == "Success":
            toast.fire("Success", "Safe Make Updated Successfully", "success");
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Safe Make Updated Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Updating Safe Make failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "The data already exists!":
            toast.fire(
              "Updating Safe Make failed ",
              `Duplication Error: ${res}`,
              "error"
            );
            break;
          case res.includes("Action object"):
            toast.fire("Updating Safe Make failed ", `Error: ${res}`, "error");
            break;
          default:
            toast.fire("Updating Safe Make failed", `${res}`, "error");
        }
      }
      // Redirect to View
      setActionEditState(false);

      // ReFetch Data
      setIsReFetching(isReFetching ? false : true);
    },
    onError: (error: any) => {
      toast.fire("Update Safe Make failed", `Error: ${error}`, "error");
    },
  });
  return mutate;
};

export default useEditSafeMake;
